import React from "react";
import { Reveal } from "@/components/Reveal";
import { TEAM, TEAM_STATEMENT } from "@/data/content";
import { UserCircle } from "@phosphor-icons/react";

export const Team = () => (
  <section id="team" data-testid="team-section" className="py-24 md:py-36 bg-[#0A1521]">
    <div className="max-w-7xl mx-auto px-6 md:px-12">
      <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-end mb-16">
        <div className="lg:col-span-7">
          <Reveal>
            <p className="text-xs uppercase tracking-[0.3em] text-gold mb-6">Meet Your Team</p>
            <h2 className="font-heading font-light text-4xl sm:text-5xl lg:text-6xl text-[#F6F4F0] leading-tight">
              Two students. One relentless standard.
            </h2>
          </Reveal>
        </div>
        <div className="lg:col-span-5">
          <Reveal delay={0.1}>
            <p className="text-[#E5E7EB] font-light leading-relaxed">{TEAM_STATEMENT}</p>
          </Reveal>
        </div>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        {TEAM.map((m, i) => (
          <Reveal key={m.name} delay={i * 0.1} className="h-full">
            <div data-testid={`team-member-${i}`} className="group h-full flex flex-col border border-[#F6F4F0]/12 hover:border-[#C8A96A]/50 bg-[#0D1B2A] transition-colors duration-300">
              {/* Photo */}
              <div className="relative aspect-[4/5] flex items-center justify-center bg-gradient-to-br from-[#101f30] to-[#0A1521] overflow-hidden">
                {m.photo ? (
                  <>
                    <img src={m.photo} alt={m.name} style={{ objectPosition: m.objectPosition || "center top" }} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                    <div className="absolute inset-0 bg-gradient-to-t from-[#0D1B2A]/50 via-transparent to-transparent" />
                  </>
                ) : (
                  <>
                    <div className="absolute inset-0 opacity-[0.04] flex items-center justify-center">
                      <span className="font-heading text-[16rem] text-[#F6F4F0] leading-none select-none">{m.initials}</span>
                    </div>
                    <div className="relative flex flex-col items-center gap-4 text-center">
                      <div className="h-24 w-24 rounded-full border border-[#C8A96A]/40 flex items-center justify-center">
                        <UserCircle size={54} weight="thin" className="text-gold/70" />
                      </div>
                      <span className="text-[10px] uppercase tracking-[0.25em] text-[#6B7280]">Photo coming soon</span>
                    </div>
                  </>
                )}
              </div>
              <div className="p-8 flex-1">
                <div className="flex items-baseline justify-between gap-4 mb-1">
                  <h3 className="font-heading text-2xl text-[#F6F4F0] group-hover:text-gold transition-colors">{m.name}</h3>
                  <span className="font-heading text-gold text-xl">{m.age}</span>
                </div>
                <p className="text-[10px] uppercase tracking-[0.2em] text-gold mb-5">{m.role}</p>
                <p className="text-[#E5E7EB] font-light text-sm leading-relaxed">{m.bio}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
